export default __webpack_public_path__ + "static/media/Star 4.3bef7530.svg";